import moment from "moment";
import React from "react";
export const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});

export const configMonthToDate = [
    { name: "displayName", label: "\n", options: { sort: false, } },
    { name: "lastMonth", label: "Last Month", options: { sort: false, } },
    { name: "thisMonth", label: "This Month", options: { sort: true, } },
    { name: "growth", label: "Growth", options: { sort: true, customBodyRender: (val) => (val!== null ? `${val}%` : null) } },
    { name: "projection", label: "Proyeksi", options: { sort: false, } },
];

export const configYearToDate = (year) => [
    { name: "paymentName", label: "\n", options: { sort: false } },
    { name: "january", label: "JAN", options: { sort: false } },
    { name: "february", label: "FEB", options: { sort: false } },
    { name: "march", label: "MAR", options: { sort: false } },
    { name: "april", label: "APR", options: { sort: false } },
    { name: "may", label: "MAY", options: { sort: false } },
    { name: "june", label: "JUN", options: { sort: false } },
    { name: "july", label: "JUL", options: { sort: false } },
    { name: "august", label: "AUG", options: { sort: false } },
    { name: "september", label: "SEP", options: { sort: false } },
    { name: "october", label: "OCT", options: { sort: false } },
    { name: "november", label: "NOV", options: { sort: false } },
    { name: "december", label: "DEC", options: { sort: false } },
    { name: "yearToDateTotal", label: year || moment().format("YYYY"), options: { sort: false } },
];

export const configYearToDateInden = (year) => [
    { name: "payment", label: "\n", options: { sort: false } },
    { name: 'january', label: "JAN", options: { sort: false } },
    { name: 'february', label: "FEB", options: { sort: false } },
    { name: 'march', label: "MAR", options: { sort: false } },
    { name: 'april', label: "APR", options: { sort: false } },
    { name: 'may', label: "MAY", options: { sort: false } },
    { name: 'june', label: "JUN", options: { sort: false } },
    { name: 'july', label: "JUL", options: { sort: false } },
    { name: 'august', label: "AUG", options: { sort: false } },
    { name: 'september', label: "SEP", options: { sort: false } },
    { name: 'october', label: "OCT", options: { sort: false } },
    { name: 'november', label: "NOV", options: { sort: false } },
    { name: 'december', label: "DEC", options: { sort: false } },
    { name: "totalVariantInYear", label: year || moment().format("YYYY"), options: { sort: false } },
];


export const configNo = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const { page, rowsPerPage } = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                return <>{rowNumber}</>;
            },
        },
    },
];

export const configLast3Years = (val) => {
  const year = val ? Number(val) : Number(moment().format("YYYY"));
  return [
    // { name: "name", label: "Nama Sales/CS", options: { sort: false } },
    { name: "year2Quartal1", label: `Q1 ${year - 2}`, options: { sort: false } },
    { name: "year2Quartal2", label: `Q2 ${year - 2}`, options: { sort: false } },
    { name: "year2Quartal3", label: `Q3 ${year - 2}`, options: { sort: false } },
    { name: "year2Quartal4", label: `Q4 ${year - 2}`, options: { sort: false } },
    { name: "year1Quartal1", label: `Q1 ${year - 1}`, options: { sort: false } },
    { name: "year1Quartal2", label: `Q2 ${year - 1}`, options: { sort: false } },
    { name: "year1Quartal3", label: `Q3 ${year - 1}`, options: { sort: false } },
    { name: "year1Quartal4", label: `Q4 ${year - 1}`, options: { sort: false } },
    { name: "yearQuartal1", label: `Q1 ${year}`, options: { sort: false } },
    { name: "yearQuartal2", label: `Q2 ${year}`, options: { sort: false } },
    { name: "yearQuartal3", label: `Q3 ${year}`, options: { sort: false } },
    { name: "yearQuartal4", label: `Q4 ${year}`, options: { sort: false } },
  ];
};

export const transformResponseLastThreeYearsToTable = (val) => {
    const data = val.dataSales.map((item, index) => ({
        no: index + 1,
        name: item.name,
        year2Quartal1: item.quartal.year2Quartal1,
        year2Quartal2: item.quartal.year2Quartal2,
        year2Quartal3: item.quartal.year2Quartal3,
        year2Quartal4: item.quartal.year2Quartal4,
        year1Quartal1: item.quartal.year1Quartal1,
        year1Quartal2: item.quartal.year1Quartal2,
        year1Quartal3: item.quartal.year1Quartal3,
        year1Quartal4: item.quartal.year1Quartal4,
        yearQuartal1: item.quartal.yearQuartal1,
        yearQuartal2: item.quartal.yearQuartal2,
        yearQuartal3: item.quartal.yearQuartal3,
        yearQuartal4: item.quartal.yearQuartal4,
    }));

    data.push({
        no: "",
        name: "TOTAL",
        year2Quartal1: val.totalYearMinus2q1,
        year2Quartal2: val.totalYearMinus2q2,
        year2Quartal3: val.totalYearMinus2q3,
        year2Quartal4: val.totalYearMinus2q4,
        year1Quartal1: val.totalYearMinus1q1,
        year1Quartal2: val.totalYearMinus1q2,
        year1Quartal3: val.totalYearMinus1q3,
        year1Quartal4: val.totalYearMinus1q4,
        yearQuartal1: val.totalThisYearq1,
        yearQuartal2: val.totalThisYearq2,
        yearQuartal3: val.totalThisYearq3,
        yearQuartal4: val.totalThisYearq4,
    });
    console.log(data)

    return data;
}

export const transformResponseYearsToDateToTable = (val) => {
    const result = [];

    // Payment Group1
    const group1 = val.paymentGroup1.map(item => ({
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));
    result.push(...group1);

    // Total Group 1
    result.push({
        paymentName: "Total",
        ...val.paymentTotalGroup1.totalPaymentPerGroup,
        yearToDateTotal: val.paymentTotalGroup1.allTotalPayment
    });

    // separator kosong
    result.push({
        paymentName: "",
        january: "",
        february: "",
        march: "",
        april: "",
        may: "",
        june: "",
        july: "",
        august: "",
        september: "",
        october: "",
        november: "",
        december: "",
        yearToDateTotal: ""
    });

    // Payment Group2 
    const group2 = val.paymentGroup2.map(item => ({
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));

    result.push(...group2);

    // Total Group 2 
    result.push({
        paymentName: "TOTAL",
        ...val.paymentTotalGroup2.totalPaymentPerGroup,
        yearToDateTotal: val.paymentTotalGroup2.allTotalPayment
    });
    
    return result;
}

const SPACER_DATA = {
  leasingName: "",
  lastMonth: null,
  thisMonth: null,
  growth: null,
  projection: null,
};

export const transformResponseMTD = (data) => {
  if (!data) return [];

  const {
    dataLeasing = [],
    dataNonLeasing = [],
    dataTotalLeasing = {},
    dataTotalNonLeasing = {},
  } = data;

  // Proses data leasing
  const combinedLeasing = [
    ...dataLeasing.map(item => ({
      ...item,
      displayName: item.leasingName,
    })),
    {
      displayName: "Total",
      lastMonth: dataTotalLeasing.totalLastMonth,
      thisMonth: dataTotalLeasing.totalThisMonth,
      growth: dataTotalLeasing.totalGrowth,
      projection: dataTotalLeasing.totalProjection,
    },
  ];

  // Proses data non-leasing
  const combinedNonLeasing = [
    ...dataNonLeasing.map(item => ({
      ...item,
      displayName: item.paymentMethod,
    })),
    {
      displayName: "Total",
      lastMonth: dataTotalNonLeasing.totalLastMonth,
      thisMonth: dataTotalNonLeasing.totalThisMonth,
      growth: dataTotalNonLeasing.totalGrowth,
      projection: dataTotalNonLeasing.totalProjection,
    },
  ];

  // Gabungkan hasil
  return [...combinedNonLeasing, SPACER_DATA, ...combinedLeasing];
};
